/**
 * @file The display text of an ISO instant in the browser's zone and locale,
 * luxon's `DATETIME_MED`. Consumers: a stored run's provenance and the run
 * actions' "Try again at" text.
 */
import { DateTime } from 'luxon';

export const analyticsInstantText = (instant: string): string =>
  DateTime.fromISO(instant).toLocaleString(DateTime.DATETIME_MED);
